import React from 'react';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useSelector } from 'react-redux';

import { formatEventTime, formatSingleDate, getTimeZoneGuess, sortArrayByProperty, getMonth, getTimeZoneLocalStorage } from '../../../../../utils';
import { LOCAL_TIME_ZONE } from '../../../../../constants';
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react-pro';

const AvailableTrainingDates = ({ sellingGroup }) => {
     const timezoneSelectedRedux = useSelector((state) => state.subscriber.timezoneSelected);
     const timezoneSelected = timezoneSelectedRedux || localStorage.getItem(LOCAL_TIME_ZONE) || getTimeZoneGuess();

     const getEventsAvailable = () => {
          const products = sellingGroup.products;

          if (!products?.length) return [];

          const eventAvailableList = [];

          for (let i = 0; i < products.length; i++) {
               const product = products[i];
               if (product.preventPurchase) continue;

               const eventsOfProduct = product.events;
               if (!eventsOfProduct) continue;

               const productEventAvailable = {
                    productId: product.id,
                    trainingDateName: product.genericPublicName,
                    events: [],
               };

               for (let j = 0; j < eventsOfProduct.length; j++) {
                    const event = eventsOfProduct[j];

                    if (event.isPrivate) continue;

                    const today = dayjs().tz(timezoneSelected);
                    const eventStartAt = event.startAt ? dayjs(event.startAt).tz(timezoneSelected) : null;

                    if (eventStartAt && eventStartAt > today) {
                         productEventAvailable.events.push({
                              id: event.id,
                              remainingSeats: event.remainingSeats > 0 ? event.remainingSeats : 0,
                              maxSeats: event.maxSeats,
                              startAt: event.startAt,
                              endAt: event.endAt,
                         });
                    }
               }

               if (productEventAvailable.events.length) {
                    // sort list event by start date
                    if (productEventAvailable.events.length > 1) {
                         sortArrayByProperty(productEventAvailable.events, 'startAt');
                    }
                    eventAvailableList.push(productEventAvailable);
               }
          }

          return eventAvailableList;
     };

     const eventAvailableList = getEventsAvailable();

     if (!eventAvailableList.length) {
          return null;
     }

     return (
          <div className="scroll-inner">
               {eventAvailableList.map((eventAvailable, key) => {
                    const events = eventAvailable.events.map((event) => {
                         const timezoneConvert = getTimeZoneLocalStorage();

                         const newStartAt = dayjs(event.startAt).tz(timezoneConvert);

                         return { ...event, startAt: event.startAt, month: getMonth(newStartAt) };
                    });

                    const groups = _(events)
                         .groupBy('month')
                         .map(function (items, month) {
                              return {
                                   month,
                                   events: _.map(items),
                              };
                         })
                         .value();

                    return (
                         <CAccordion key={key} className="available-dates">
                              <p className="title mt-4">{`Available Training Dates of ${eventAvailable.trainingDateName}`}</p>

                              {groups.map((item) => {
                                   return (
                                        <CAccordionItem key={item.month}>
                                             <CAccordionHeader>{item.month}</CAccordionHeader>
                                             <CAccordionBody>
                                                  <table className="table-training-date">
                                                       <thead>
                                                            <tr className="t-header">
                                                                 <th>Training Dates</th>
                                                                 <th>Time</th>
                                                            </tr>
                                                       </thead>
                                                       <tbody>
                                                            {item.events.map((event) => {
                                                                 let availableSeat = event.remainingSeats ? '' : `${event.maxSeats} seats available`;

                                                                 if (event.remainingSeats < 1) {
                                                                      availableSeat = 'Sold Out';
                                                                 } else if (event.remainingSeats === 1) {
                                                                      availableSeat = event.remainingSeats + ' seat available';
                                                                 } else {
                                                                      availableSeat = event.remainingSeats + ' seats available';
                                                                 }

                                                                 const availableSeatClass = event.remainingSeats < 1 ? 'text-danger' : '';

                                                                 return (
                                                                      <tr key={event.id}>
                                                                           <td>
                                                                                <p className="mb-0">
                                                                                     {formatSingleDate(event.startAt)}
                                                                                     <span
                                                                                          className={`number-available-seats ${availableSeatClass}`}
                                                                                     >{` (${availableSeat})`}</span>
                                                                                </p>
                                                                           </td>
                                                                           <td>
                                                                                <p className="mb-0">{formatEventTime(event.startAt, event.endAt)}</p>
                                                                           </td>
                                                                      </tr>
                                                                 );
                                                            })}
                                                       </tbody>
                                                  </table>
                                             </CAccordionBody>
                                        </CAccordionItem>
                                   );
                              })}
                         </CAccordion>
                    );
               })}
          </div>
     );
};

export default AvailableTrainingDates;
